import React, { Component } from 'react'
import { TIMER, TIMER_DELAY } from '../config'
const requestAnimationFrame = window.requestAnimationFrame

class Timer extends Component {
  state = {
    ellapsed: 0
  }

  componentDidMount() {
    this.abort = false
    setTimeout(() => {
      this.start = new Date().getTime()
      requestAnimationFrame(this.isDone)
    }, TIMER_DELAY)
  }

  componentWillUnmount() {
    this.abort = true
  }

  isDone = () => {
    if (this.abort) return
    const { done } = this.props
    if (done) {
      this.complete()
    } else {
      this.ticking()
    }
  }

  complete() {
    this.setState({ ellapsed: TIMER })
  }

  ticking = () => {
    const now = new Date().getTime()
    const ellapsed = (now - this.start) / 1000
    const { onTimeDone } = this.props
    if (ellapsed < TIMER) {
      this.setState({ ellapsed })
      requestAnimationFrame(this.isDone)
    } else {
      this.setState({ ellapsed: TIMER })
      onTimeDone()
    }
  }

  render() {
    const { ellapsed } = this.state
    const width = ellapsed * 100 / TIMER
    const { color } = this.props
    return (
      <div
        style={{
          height: 6,
          backgroundColor: '#32455F',
          BorderRadiusTopleft: 13,
          BorderRadiusTopright: 13
        }}
      >
        <div
          style={{
            width: `${width}%`,
            height: 6,
            backgroundColor: color
          }}
        />
      </div>
    )
  }
}

export default Timer



// WEBPACK FOOTER //
// ./src/components/Timer.js